/*
  CashStrap page for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col } from 'react-bootstrap'

function CashStrap () {
  return (
    <>
      <Helmet>
        <title>Cashstrap - Build Your Own Full Stack - FullStack.cash</title>
      </Helmet>

      <Container className='py-5'>
        <Row>
          <Col>
            <h1 className='text-center mb-4'>Cashstrap - Bootstrap the Cash Stack</h1>
            <p className='text-center'>
              Reach out
              to <a href='https://t.me/bch_js_toolkit' target='_blank' rel='noreferrer'>our Telegram channel</a> if you
              need help building your infrastructure.
            </p>

            <p>
              Below are download links for downloading historical backups of 
              the <a href='https://cashstack.info/docs/back-end/slp-indexer/slp-indexer-software' target='_blank' rel='noreferrer'>PSF SLP indexer</a>. The best way to download these files are
              with wget on the command terminal:
            </p>
            <ul>
              <li>
                <code>
                  wget https://download.fullstackcash.net/slp-indexer-925000.zip
                </code>
              </li>
            </ul>

            <p>
              If your download is interrupted, you can resume the download like this:
              <ul>
                <li>
                  <code>
                    wget -c https://download.fullstackcash.net/slp-indexer-925000.zip
                  </code>
                </li>
              </ul>
            </p>
          </Col>
        </Row>
        <br />

        <Row>
          <Col>
            <h2 className='text-center mb-4'>PSF SLP Indexer</h2>
            
            <ul>
              <li>
                <a href='https://download.fullstackcash.net/slp-indexer-925000.zip' target='_blank' rel='noreferrer'>
                  slp-indexer-925000.zip
                </a>
              </li>

              <li>
                <a href='https://download.fullstackcash.net/slp-indexer-805000.zip' target='_blank' rel='noreferrer'>
                  slp-indexer-805000.zip
                </a>
              </li>

              <li>
                <a href='https://download.fullstackcash.net/slp-indexer-750000.zip' target='_blank' rel='noreferrer'>
                  slp-indexer-750000.zip
                </a>
              </li>

              <li>
                <a href='https://download.fullstackcash.net/slp-indexer-710000.zip' target='_blank' rel='noreferrer'>
                  slp-indexer-710000.zip
                </a>
              </li>

              <li>
                <a href='https://download.fullstackcash.net/slp-indexer-650000.zip' target='_blank' rel='noreferrer'>
                  slp-indexer-650000.zip
                </a>
              </li>

              <li>
                <a href='https://download.fullstackcash.net/slp-indexer-608000.zip' target='_blank' rel='noreferrer'>
                  slp-indexer-608000.zip
                </a>
              </li>

              <li>
                <a href='https://download.fullstackcash.net/slp-indexer-575000.zip' target='_blank' rel='noreferrer'>
                  slp-indexer-575000.zip
                </a>
              </li>
            </ul>

            <h2 className='text-center mb-4'>BCHN Full Node &amp; Fulcrum Indexer</h2>
            
            <ul>
              <li>
                <a href='https://download.fullstackcash.net/bchn-2025-11-18-925569.zip' target='_blank' rel='noreferrer'>
                  bchn-2025-11-18-925569.zip
                </a>
              </li>

              <li>
                <a href='https://download.fullstackcash.net/fulcrum-11-18-25.zip' target='_blank' rel='noreferrer'>
                  fulcrum-11-18-25.zip
                </a>
              </li>
            </ul>

            <h2 className='text-center mb-4'>Memo Indexer</h2>
            
            <ul>
              <li>
                <a href='https://download.fullstackcash.net/memo-indexer-955000.zip' target='_blank' rel='noreferrer'>
                  memo-indexer-955000.zip
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default CashStrap
